export default __webpack_public_path__ + "static/media/signup_white.1c58cbe3.svg";